import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const usePageTitle = () => {
    const { t, i18n } = useTranslation()
    const location = useLocation()

    useEffect(() => {
        // Update document title based on current route
        const knownRoutes = ['/', '/about', '/privacy', '/imprint', '/terms', '/event-rules']
        let pageTitle = t('pages.home') // default

        if (location.pathname === '/about') {
            pageTitle = t('pages.about')
        } else if (location.pathname === '/privacy') {
            pageTitle = t('pages.privacy')
        } else if (location.pathname === '/imprint') {
            pageTitle = t('pages.imprint')
        } else if (location.pathname === '/terms') {
            pageTitle = t('pages.terms')
        } else if (location.pathname === '/event-rules') {
            pageTitle = t('pages.eventRules')
        } else if (location.pathname === '/') {
            pageTitle = t('pages.home')
        } else if (!knownRoutes.includes(location.pathname)) {
            // 404 page
            pageTitle = t('pages.notFound')
        }

        document.title = pageTitle

        // Update HTML lang attribute
        const htmlLang = i18n.language === 'de-DE' ? 'de' : 'en'
        document.documentElement.lang = htmlLang
    }, [location.pathname, t, i18n.language])
}

